
import Vue, { PropType } from "vue";
import { Toilet, ToiletType, ToiletStatus } from "@/models";
import BaseDropDown, { OptionItem } from "@/components/BaseDropDown.vue";

export type DataType = {
  options: OptionItem[];
  showing: boolean;
};

export default Vue.extend({
  name: "ToiletListItem",

  components: {
    BaseDropDown,
  },

  props: {
    toilet: Object as PropType<Toilet>,
  },

  computed: {
    isAdmin(): boolean {
      return this.$auth.role === "admin";
    },

    toiletTypeText(): string {
      switch (this.toilet?.toiletType) {
        case ToiletType.FOR_MAN:
          return "男性トイレ";
        case ToiletType.FOR_WOMAN:
          return "女性トイレ";
        case ToiletType.UNISEX:
          return "共用";
        case ToiletType.MULTI_PURPOSE:
          return "多目的トイレ";
        default:
          return "不明";
      }
    },

    gatewayMac(): string {
      return this.toilet?.gatewayMac || "なし";
    },

    numOfBoxes(): string {
      return String(this.toilet?.boxesCount || 0);
    },

    floorPlanUrl(): string | undefined {
      return this.toilet?.floorPlanUrl;
    },

    statusText(): string {
      switch (this.toilet?.status) {
        case ToiletStatus.RUNNING:
          return "稼動";
        case ToiletStatus.IN_MAINTENANCE:
          return "メンテ中";
        case ToiletStatus.IN_PREPARING:
          return "準備中";
        default:
          return "不明";
      }
    },

    statusClassText(): string {
      switch (this.toilet?.status) {
        case ToiletStatus.RUNNING:
          return "";
        case ToiletStatus.IN_MAINTENANCE:
          return "red";
        case ToiletStatus.IN_PREPARING:
          return "red";
        default:
          return "";
      }
    },

    editMenuClassText(): string {
      return this.showing ? "active" : "";
    },
  },

  data(): DataType {
    return {
      options: [
        {
          label: "エリア情報 編集",
          classes: [],
          disabled: this.$auth.role !== "admin",
          clickAction: () => {
            this.$router.push({
              name: "company-toilet-detail",
              params: {
                toiletId: this.toilet.id as string,
              },
            });
          },
        },
        {
          label: "エリア情報 削除",
          classes: ["red"],
          disabled: this.$auth.role !== "admin" || this.toilet.boxesCount !== 0,
          clickAction: () => {
            this.$router.push({
              name: "company-toilet-delete",
              params: {
                toiletId: this.toilet.id as string,
              },
            });
          },
        },
        {
          label: "個室管理",
          classes: [],
          clickAction: () => {
            this.$router.push({
              name: "company-toilet-boxes",
              params: {
                toiletId: this.toilet.id as string,
              },
            });
          },
        },
      ],
      showing: false,
    };
  },
});
